import { FC } from 'react';
import { Link } from '../../components/Link.client';

interface Props {
  routes: {
    title: string;
    path: string;
  }[];
}

export const Breadcrumb: FC<Props> = ({ routes }) => (
  <div className="hidden md:block">
    <div className="wrapper mt-6 flex">
      <BreadcrumbItem title="&COCO HOME" path="/" />
      {routes.map((route, i) => (
        <BreadcrumbItem title={route.title} path={route.path} key={i} />
      ))}
    </div>
  </div>
);

const BreadcrumbItem: FC<Props['routes'][number]> = ({ title, path }) => (
  <Link
    route="url"
    url={path}
    className="inline border-l border-solid border-lightGray px-2 first:border-l-0"
  >
    <p className="whitespace-nowrap text-xs text-gray">{title}</p>
  </Link>
);
